import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "../CSS/waitlistLandingPage.css";
import Meta from "../Components/Meta.js";
import { getBikeByName, getAllBikes } from "../Actions/bikeActions.js";
import { useDispatch, useSelector } from "react-redux";
import ModalMobile from "../Components/ModalMobile.js";
import { Link } from "react-router-dom";

function WaitlistLandigPage() {
  return (
    <>
      <Meta
        title={"Buy Latest EMotorad Electric Bicycle | Latest Collection"}
        description={
          "Get ahead with the latest EMotorad electric bicycles. Our new collection offers enhanced features, superior comfort, and unmatched performance."
        }
      />
      <Navbar />
      <div className="position-relative">
        <picture>
          <source
            media="(max-width:650px)"
            srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/prebook25Mobile.jpg"
          />
          <source
            media="(min-width:651px)"
            srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/prebook25.jpg"
          />
          <img
            src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/prebook25.jpg"
            className="img-fluid w-100"
            alt=""
            srcSet=""
          />
        </picture>
        <div className="position-absolute kalki-banner-btn">
          <ModalMobile
            className="kalki-btn py-3 px-4 px-lg-5"
            text="PRE-BOOK NOW @ ₹1999"
          />
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}

export default WaitlistLandigPage;
